import VehiclesTable from '../../components/vehicles/VehiclesTable'
import { connect } from 'react-redux'
import { actionCreators } from '../../state/actions/vehicles/index'
import { IStoreState, IVehicleObj, IVehicleFilters } from '../../types'
import { getDriversList, getSingleDriver } from '../../state/actions/drivers'
import * as actions from '../../state/actions/vehicles/'
import { integrationService } from 'src/services/Integration'

export function mapStateToProps(state: IStoreState) {
  const vehiclesAndCount =
    state.vehicles && state.vehicles.items && state.vehicles.items.result
      ? { vehicles: Object.values(state.vehicles.items.result), totalCount: state.vehicles.items.count }
      : { vehicles: null, totalCount: 0 }
  return {
    organizationId: state.organizations.currentOrgId,
    vehicles: vehiclesAndCount.vehicles,
    totalCount: vehiclesAndCount.totalCount,
    operators: state.drivers.items,
    selectedVehicles: state.vehicles.selectedVehicles,
    isFetch: state.vehicles.isItemsFetching,
    error: state.vehicles.error,
    isDeactivatingVehicle: /*state.vehicles.isDeactivating*/ false,
    filters: state.vehicles.filters
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchAllVehicles: (params: IVehicleFilters) => {
      dispatch(actions.getVehicles(params))
    },
    loadDriver: (id: string) => {
      return dispatch(getSingleDriver(id))
    },
    deactivateVehicleAndFetchAllVehicles: (params: IVehicleFilters, id: string) => {
      if (params.organizationId) {
        return dispatch(actions.deactivateVehicle(id)).then(() => dispatch(actions.getVehicles(params)))
      }
    },
    activateVehicleAndFetchAllVehicles: (params: IVehicleFilters, id: string) => {
      if (params.organizationId) {
        return dispatch(actions.activateVehicle(id)).then(() => dispatch(actions.getVehicles(params)))
      }
    },
    removeVehicleAndFetchAllVehicles: (params: IVehicleFilters, id: string) => {
      if (params.organizationId) {
        return dispatch(actions.removeVehicle(id)).then(() => dispatch(actions.getVehicles(params)))
      }
    },
    unassignDriver: (id: string, operatorId: string, params: IVehicleFilters) => {
      return dispatch(actions.unassignDriver(id, operatorId, params))
    },
    updateVehicleFilters: (params: IVehicleFilters) => dispatch(actionCreators.updateVehicleFilters(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehiclesTable)



// WEBPACK FOOTER //
// ./src/containers/vehicles/VehiclesTable.ts